export default __webpack_public_path__ + "static/media/youtube.8442b0dd.jpg";